import { SectionTypes } from "@launchos/modules/v2/Properties/types";
// import theme from "@launchos/components/ui/theme";
import theme from "@launchos/plugins/misc/v2/blocks/weblayouts/theme";
import { IComponentSettings, ComponentTypes } from "../../types";
import { CountDownTypes } from "./types";

export const style = {
  COUNTDOWN: {
    style: {
      margin: "0 auto",
      display: "inline-block",
    },
    dimensionStyle: {
      minWidth: 80,
    },
    numberStyle: {
      textAlign: "center",
      fontSize: "26pt",
      fontFamily: theme.fontFamily,
      fontWeight: "bold",
      padding: 10,
      backgroundColor: "#333",
      // backgroundColor: theme.backgroundColor,
      color: theme.foregroundColor,
      margin: 5,
    },
    labelStyle: {
      fontWeight: "bold",
      fontFamily: theme.fontFamily,
      fontSize: "0.85rem",
    },
    dividerStyle: {
      padding: 10,
      fontWeight: "bold",
      fontFamily: theme.fontFamily,
    },
  },
};

const settings: IComponentSettings = {
  id: ComponentTypes.COUNTDOWN,
  name: "Countdown",
  description: "",
  thumbnail: "comp_countdowns.png",
  default: {
    type: ComponentTypes.COUNTDOWN,
    countType: CountDownTypes.EVENT,
    eventDate: Date.now() + 365 * 24 * 60 * 60 * 1000,
    // properties: style.COUNTDOWN.style,
    properties: {
      textAlign: "center",
      display: "inline-block",
    },
    dimensionStyle: style.COUNTDOWN.dimensionStyle,
    labelStyle: style.COUNTDOWN.labelStyle,
    numberStyle: style.COUNTDOWN.numberStyle,
    dividerStyle: style.COUNTDOWN.dividerStyle,
    showDivider: false,
  },
};

export default settings;
